import { render, staticRenderFns } from "./OutstandingStatistic.vue?vue&type=template&id=1020efbc&scoped=true"
import script from "./OutstandingStatistic.vue?vue&type=script&lang=ts"
export * from "./OutstandingStatistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020efbc",
  null
  
)

export default component.exports